<div
    class="card mb-3 shadow-sm no-select"
    [class.card-disabled]="!organization.active"
    [class.card-active]="isActive"
    (click)="toggleActive(organization.id)"
>
    <div class="card-body py-2">
        <div
            class="row no-gutters align-items-center"
            [routerLink]="isAdminProfile ? ['/administration/organizations', organization.id] : ['/organizations', organization.id]"
        >
            <div class="col-auto mr-3">
                <app-organization-avatar [organizationName]="organization.name" [pictureAccessLink]="organization.pictureAccessLink">
                </app-organization-avatar>
            </div>

            <div class="col">
                <div class="underline">
                    <p
                        *ngIf="isAdminProfile; else organizationProfileLink"
                        class="mb-0 font-weight-bold"
                        [routerLink]="['/administration/organizations', organization.id]"
                    >
                        {{ organization.name }}
                    </p>
                    <ng-template #organizationProfileLink>
                        <p class="mb-0 font-weight-bold" [routerLink]="['/organizations', organization.id]">
                            {{ organization.name }}
                        </p>
                    </ng-template>
                </div>
                <div class="d-flex align-items-center mb-1" *ngIf="organization.businessAreaName">
                    <span class="primary-1" [title]="organization.businessAreaName">
                        {{
                            organization.businessAreaName.length > 30
                                ? (organization.businessAreaName | wtranslate : 'businessAreas' | slice : 0 : 28) + '...'
                                : (organization.businessAreaName | wtranslate : 'businessAreas')
                        }}
                    </span>
                </div>
            </div>
        </div>

        <div>
            <div class="d-flex align-items-center" *ngIf="this.organization?.employeesCount > 0; else noMembers">
                <em class="icon icon-employees mr-2"></em>
                <span class="more underline" type="button" (click)="openMembersModal($event)">
                    {{ getCollaboratorsText(this.organization?.employeesCount) }}
                </span>
                <app-organization-members-modal [organizationId]="this.organization?.id" #membersModal></app-organization-members-modal>
            </div>

            <ng-template #noMembers>
                <span>
                    {{ getCollaboratorsText(0) }}
                </span>
            </ng-template>
            <div class="d-flex align-items-center mb-1" *ngIf="organization.geographicalAreaName">
                <em class="icon icon-marker mr-2"></em>
                <span>
                    {{
                        organization.geographicalAreaName.length > 30
                            ? (organization.geographicalAreaName | slice : 0 : 28) + '...'
                            : organization.geographicalAreaName
                    }}
                </span>
            </div>
        </div>
    </div>
</div>
